import React from "react";
import { v4 } from "uuid";

export const isObject = x => {
  return x && typeof x === "object" && x.constructor === Object;
};

export const guid = () => {
  return v4().replace(/(\r|\n|\t|\s)/g, "");
};

/*
object-key-validator
https://github.com/JakeDawkins/object-key-validator
*/
export const validateKeys = (rule, obj) => {
  const [ruleType] = Object.keys(rule);
  if (
    ruleType !== "$not" &&
    (!Array.isArray(rule[ruleType]) || !rule[ruleType].length)
  )
    throw new Error("invalid rule");
  return ruleType === "$not"
    ? !validateKeys(rule.$not, obj)
    : rule[ruleType]
        .map(r =>
          typeof r === "string"
            ? obj[r] !== undefined && obj[r] !== null
            : validateKeys(r, obj)
        )
        .reduce(reducers[ruleType], ruleType === "$and");
};

const reducers = {
  $and: (acc, val) => acc && val,
  $or: (acc, val) => acc || val
};
// end validator

// Returns a String, which is all the data attributes.
// Example <Button data={ [ { name: “fullstory-name”, value: “surety-home-button” } ] } />
export const createDataAttributes = data => {
  if (!data || !data.length) return;

  const spreadableAttributes = {};

  data.forEach(({ name, value }) => {
    if (name) name = name.replace(/\s+/g, "-");
    spreadableAttributes[`data-${name}`] = value;
  });

  return spreadableAttributes;
};

export const recursiveMap = (children, fn) => {
  return React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return child;
    }

    if (child.props.children) {
      child = React.cloneElement(child, {
        children: recursiveMap(child.props.children, fn)
      });
    }

    return fn(child);
  });
};
